import { type ConfiguredQuickEntryItem, type QuickEntryItem, type QuickEntryItemPC } from "../types/models";
import { hasFixedPriceReference, userCanSeePriceReference } from "~/features/cart/cart/components/LineItemStaticParams";
import type { PriceReferenceSelection } from "~/domains/priceReference/types";

export const canSeePriceRefColumn = (selection?: PriceReferenceSelection) => userCanSeePriceReference(selection);

export const canSeeStaticPriceRefColumn = (selection?: PriceReferenceSelection) => hasFixedPriceReference(selection);

export const noPriceReference = (selection?: PriceReferenceSelection) => !selection || selection.options.length === 0;

export const hasProductConfigured = (item: QuickEntryItem): item is ConfiguredQuickEntryItem => !!item.product;
export const hasProductConfiguredPC = (item: QuickEntryItemPC): item is ConfiguredQuickEntryItem => !!item.product;
